import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-4 w-4 inline-block rounded border border-gray-300 bg-gray-100 cursor-not-allowed"
}
const _hoisted_2 = { class: "ml-2" }

import { useForm } from "vee-validate";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import OaiListbox from "shared/components/other/OaiListbox.vue";
import {
  WorkingHourCurveReportConfig,
  WorkingHourCurveReportFilters,
} from "@/types/reports/PlotWorkingHourCurve";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkingHourCurveConfigFields',
  props: {
    config: {},
    filters: {}
  },
  emits: ["configChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();
const { defineField } = useForm();

const [mode] = defineField("mode");
const [showMean] = defineField("show_mean");

const modes = [
  { value: "default", name: t("analytics.reports.default_mode") },
  { value: "cumulative", name: t("analytics.reports.cumulative_mode") },
];

watch(
  () => props.config,
  () => {
    mode.value = props.config.mode;
    showMean.value = props.config.show_mean;
  },
  { immediate: true },
);

const handleConfigChange = () => {
  const config: WorkingHourCurveReportConfig = {
    mode: mode.value,
    show_mean: showMean.value,
  };
  emit("configChange", config);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(OaiListbox, {
      options: modes,
      name: "mode",
      defaultSelected: _unref(mode),
      label: _unref(t)('analytics.reports.plot_modes'),
      "onUpdate:selected": (value) => (mode.value = value, handleConfigChange())
    }, null, 8, ["defaultSelected", "label", "onUpdate:selected"]),
    _createElementVNode("label", {
      class: _normalizeClass(['flex cursor-pointer items-center w-fit mt-4', _unref(mode) === 'default' && 'cursor-pointer'])
    }, [
      (_unref(mode) !== 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "checkbox",
            name: "show_mean",
            class: "h-4 w-4 rounded border-gray-300 text-yellow-500 focus:ring-yellow-500",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showMean) ? (showMean).value = $event : null)),
            onChange: handleConfigChange
          }, null, 544)), [
            [_vModelCheckbox, _unref(showMean)]
          ]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("analytics.reports.show_mean_working_hours")), 1)
    ], 2)
  ], 64))
}
}

})